import React, { useState, useEffect } from "react";
import { Button, Row, Col, Container, Form } from "react-bootstrap"
import axios from "axios";
import toast from "react-hot-toast";
import ToastComponent from "./components/ToastComponent";
import Table from "./components/Table";
import Panel from "./components/Panel";

function HaDevices() {
  const [hadevices, setHadevices] = useState();
  const [result, setResult] = useState();
  const [name, setName] = useState();


  const getHadevices = () => {
    axios
    .get(`${process.env.REACT_APP_API ? process.env.REACT_APP_API : window.location.origin}/gui/v1/ha_devices.json`)
    .catch((error) => console.error(error))
    .then(({ data }) => {
      setHadevices(data.ha_devices)
    })
  }

  const createDevice = () => {
    let senddata =
      axios.post(`${process.env.REACT_APP_API ? process.env.REACT_APP_API : window.location.origin}/gui/v1/ha_device.json`,
        {
          ha_device: {
            name: name,
          }
        }
      )
      .then(( { data }) => {
        setResult(data)
      
      toast.promise(senddata, {
        loading: "Creating device",
        success: "device Created",
        error:   "Could not create device"
      })
      getHadevices()
    })
  }


useEffect(() => {
  getHadevices();
}, []);

const gridOptions = {
  getRowId(data) {
    return data.data.id;
  },
  paginationPageSize: 32,
  columnDefs: [
    {
      headerName: "Name",
      cellRenderer: function(params) {
        return (<a href={`/hadevice/${params.data.id}`}>{params.data.name}</a>)
      }
    }, {
      headerName: "URL",
      cellRenderer: function(params) {
        return (<a href={`${params.data.url}`} target="_blank">{params.data.url}</a>)
      }
    }, {
      headerName: "IP Address",
      field: "ipaddress"
    }, {
      headerName: "IP at 32bit",
      field: "ip32int"
    }, {
      headerName: "Active",
      field: "active"
    }, {
      headerName: "Customer",
      cellRenderer: function(params) {
        if (params.data.customer_id) {
          return (<a href={`/customer/${params.data.customer_id}`}>{params.data.customer.surname}, {params.data.customer.first_name}</a>)
        } else {
          return ( <p>Unassigned</p>)
        }
      }
    }
  ]
}

return (
  <div className="App">
    <ToastComponent />
      <Panel>
      <h1>HA Devices</h1>
      <Container>
        <Form>
          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
          <Form.Label column sm="2" className="Register-Label">
                Name
              </Form.Label>
              <Col sm="10">
                <Form.Control onChange={(e) => setName(e.target.value)} />
              </Col>
          </Form.Group>

        </Form>
        <Button onClick={() => createDevice()}>Create</Button>
      </Container>

      <Table gridOptions={gridOptions} rowData={hadevices}/>
      </Panel>
  </div>


)

}

export default HaDevices